import React from 'react';
import { Loader } from 'modules/core/components';

import { PreloaderPosition } from './styles';

const Preloader: React.FC = () => (
  <PreloaderPosition>
    <Loader />
  </PreloaderPosition>
);

export default Preloader;
